import { render, staticRenderFns } from "./Numeros.vue?vue&type=template&id=5570564a&scoped=true"
import script from "./Numeros.vue?vue&type=script&lang=js"
export * from "./Numeros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5570564a",
  null
  
)

export default component.exports